/** Fechas en zona Ciudad de México */

export function formatMxShort(iso) {
  const d = new Date(iso);
  return d.toLocaleString("es-MX", {
    timeZone: "America/Mexico_City",
    weekday: "short",
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatMxLong(iso) {
  const d = new Date(iso);
  return d.toLocaleString("es-MX", {
    timeZone: "America/Mexico_City",
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function todayMxYmd() {
  return new Date().toLocaleDateString("en-CA", {
    timeZone: "America/Mexico_City",
  });
}

/** YYYY-MM-DD en zona Ciudad de México a partir de un ISO UTC. */
export function utcToMxYmd(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleDateString("en-CA", {
    timeZone: "America/Mexico_City",
  });
}

/** year y month son 1-based (enero = 1). */
export function filterAppointmentsInMxMonth(appointments, year, month) {
  const prefix = `${year}-${String(month).padStart(2, "0")}`;
  return (appointments || []).filter((a) =>
    utcToMxYmd(a.startUtc).startsWith(prefix)
  );
}

/** Hora 0–23 en zona Ciudad de México (para agrupar mañana/tarde). */
export function hourInMexicoCity(iso) {
  const d = new Date(iso);
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/Mexico_City",
    hour: "numeric",
    hour12: false,
  }).formatToParts(d);
  const h = parts.find((p) => p.type === "hour");
  return h ? parseInt(h.value, 10) : 0;
}

/** Solo hora legible CDMX, compacta para rejillas (ej. 9:30 a. m.). */
export function formatTimeMxOnly(iso) {
  return new Date(iso).toLocaleTimeString("es-MX", {
    timeZone: "America/Mexico_City",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}

export function formatTimeMxFlexible(iso, hour12) {
  return new Date(iso).toLocaleTimeString("es-MX", {
    timeZone: "America/Mexico_City",
    hour: "2-digit",
    minute: "2-digit",
    hour12,
  });
}
